import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AnimatedButtonComponent } from './animated-button.component';

@NgModule({
    imports: [
        CommonModule,
        FontAwesomeModule,
        TranslateModule.forChild()
    ],
    exports: [AnimatedButtonComponent],
    declarations: [AnimatedButtonComponent]
})
export class AnimatedButtonModule {
}
